import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20wooden%20table%20with%20abundant%20brunch%20spread%20from%20above%2C%20fresh%20pastries%2C%20colorful%20fruits%2C%20cheeses%2C%20cold%20cuts%2C%20hot%20coffee%20cups%2C%20orange%20juice%20glasses%2C%20soft%20natural%20morning%20light%2C%20cozy%20rustic%20atmosphere%2C%20food%20photography%20overhead%20flat%20lay%2C%20inviting%20and%20generous%20breakfast%20table&width=1440&height=900&seq=hero-brunch-1&orientation=landscape"
          alt="Table de brunch chaleureuse"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/85 via-slate-900/60 to-slate-900/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-24 pb-16">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-teal-500/20 border border-teal-400/40 rounded-full px-4 py-2 mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-heart-pulse-line text-teal-400 text-sm"></i>
            </div>
            <span className="text-teal-300 text-sm font-medium">Pour les diabétiques de type 1</span>
          </div>

          <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6">
            Gérez vos glucides{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-emerald-400">
              simplement
            </span>
          </h1>

          <p className="text-lg md:text-xl text-slate-300 leading-relaxed mb-8 max-w-xl">
            DT1 Simply Menu vous aide à composer vos repas, calculer vos glucides en temps réel et obtenir votre Nutri-Score pour une meilleure gestion de votre diabète.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/plat-personnalise"
              className="inline-flex items-center justify-center gap-2 bg-teal-500 hover:bg-teal-400 text-white px-8 py-4 rounded-xl font-semibold text-base transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-magic-line"></i>
              Créer mon repas
            </Link>
            <Link
              to="/info-aliment"
              className="inline-flex items-center justify-center gap-2 bg-white/15 hover:bg-white/25 border border-white/30 text-white px-8 py-4 rounded-xl font-semibold text-base transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-database-2-line"></i>
              Explorer les aliments
            </Link>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap gap-6 mt-12">
            {[
              { icon: 'ri-database-2-line', value: '200+', label: 'Aliments référencés' },
              { icon: 'ri-calculator-line', value: '100%', label: 'Calcul automatique' },
              { icon: 'ri-shield-check-line', value: 'A-E', label: 'Nutri-Score inclus' },
            ].map((stat) => (
              <div key={stat.label} className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg">
                  <i className={`${stat.icon} text-teal-400 text-lg`}></i>
                </div>
                <div>
                  <div className="text-white font-bold text-lg leading-none">{stat.value}</div>
                  <div className="text-slate-400 text-xs">{stat.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs">Découvrir</span>
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/50"></i>
        </div>
      </div>
    </section>
  );
}